var _defs, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _path6, _path7, _g5, _path8, _path9, _path0, _path1, _path10, _path11, _g6, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1034",
    "data-name": "Group 1034",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300.001,
    height: 287.708,
    viewBox: "0 0 300.001 287.708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2005",
    "data-name": "Rectangle 2005",
    width: 300.001,
    height: 287.708,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2004",
    "data-name": "Rectangle 2004",
    width: 300.002,
    height: 287.707,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1998",
    "data-name": "Rectangle 1998",
    width: 218.428,
    height: 127.332,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1999",
    "data-name": "Rectangle 1999",
    width: 115.609,
    height: 67.394,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2000",
    "data-name": "Rectangle 2000",
    width: 182.113,
    height: 106.163,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2001",
    "data-name": "Rectangle 2001",
    width: 89.56,
    height: 107.931,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2002",
    "data-name": "Rectangle 2002",
    width: 47.129,
    height: 47.13,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2003",
    "data-name": "Rectangle 2003",
    width: 43.785,
    height: 43.783,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1033",
    "data-name": "Group 1033",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1032",
    "data-name": "Group 1032",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1031",
    "data-name": "Group 1031",
    clipPath: "url(#clip-path-2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M467.081,435.174c59.595-2.833,105.315-67.23,105.767-126.714.5-65.971-54.834-105.439-64.436-111.995-33.4-22.809-98.175-46.686-140.856-13.99-47.435,36.338-32.589,115.751-16.223,155.347,4.29,10.38,43.176,100.8,115.747,97.352",
    transform: "translate(-297.421 -147.563)",
    fill: "#ecf3fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015",
    transform: "translate(81.573 54.974)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M933.83,552.636a42.988,42.988,0,0,0-39.976-27.161c-.17,0-.326,0-.5.014-1.218-.1-2.45-.141-3.7-.141a49.3,49.3,0,0,0-20.448,4.418,54.52,54.52,0,0,0-105.228-9.134h-.127a45.428,45.428,0,0,0-.382,90.855v.014H895.03v-.028a43.012,43.012,0,0,0,41.831-42.992,42.42,42.42,0,0,0-3.03-15.846",
    transform: "translate(-718.432 -484.169)",
    fill: "#4786d1"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M739.38,491.9h.127a54.52,54.52,0,0,1,105.228,9.134,49.3,49.3,0,0,1,20.448-4.418c1.246,0,2.478.042,3.7.141.17-.014.326-.014.5-.014a42.988,42.988,0,0,1,39.976,27.16,42.417,42.417,0,0,1,3.031,15.846,43.012,43.012,0,0,1-41.831,42.992v.028H739v-.014a45.428,45.428,0,0,1,.382-90.855",
    transform: "translate(-615.159 -403.721)",
    fill: "#3b82f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018",
    transform: "translate(2.436 57.474)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1017",
    "data-name": "Group 1017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M135.463,542.428A22.753,22.753,0,0,0,114.3,528.053c-.09,0-.172,0-.262.008-.645-.052-1.3-.075-1.956-.075a26.092,26.092,0,0,0-10.823,2.338,28.856,28.856,0,0,0-55.695-4.834H45.5a24.044,24.044,0,0,0-.2,48.087v.007h69.627v-.015a22.765,22.765,0,0,0,22.14-22.755,22.453,22.453,0,0,0-1.6-8.387",
    transform: "translate(-21.458 -506.19)",
    fill: "#4786d1"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M24.044,500.11h.067a28.856,28.856,0,0,1,55.695,4.834,26.092,26.092,0,0,1,10.823-2.339c.66,0,1.312.022,1.956.075.09-.007.172-.007.262-.007A22.753,22.753,0,0,1,114,517.049a22.452,22.452,0,0,1,1.6,8.387,22.765,22.765,0,0,1-22.14,22.754v.015H23.841V548.2a24.044,24.044,0,0,1,.2-48.087",
    transform: "translate(0 -426.219)",
    fill: "#52d1bd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021",
    transform: "translate(70.91 110.524)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M768.76,1003.807h-.106a45.456,45.456,0,0,0-87.733,7.615,41.1,41.1,0,0,0-17.048-3.684c-1.039,0-2.066.035-3.082.118-.141-.011-.271-.011-.413-.011a35.841,35.841,0,0,0-33.329,22.645,35.366,35.366,0,0,0-2.527,13.211,35.861,35.861,0,0,0,34.876,35.844v.024H769.078v-.012a37.876,37.876,0,0,0-.319-75.75",
    transform: "translate(-624.521 -973.406)",
    fill: "#4786d1"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M741.927,976.667h-.106a45.456,45.456,0,0,0-87.733,7.615,41.1,41.1,0,0,0-17.048-3.684c-1.039,0-2.066.035-3.082.118-.141-.011-.271-.011-.413-.011a35.842,35.842,0,0,0-33.329,22.645,35.365,35.365,0,0,0-2.526,13.211,35.861,35.861,0,0,0,34.876,35.844v.024H742.245v-.011a37.876,37.876,0,0,0-.319-75.75",
    transform: "translate(-529.824 -838.824)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024",
    transform: "translate(114.745 153.303)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1023",
    "data-name": "Group 1023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M1055.366,1350.181l-14.7,14.7h0l-30.086,30.086,14.7,14.7,18.54-18.539v66.989H1066.9v-67l18.54,18.54,14.7-14.7Z",
    transform: "translate(-1010.582 -1350.181)",
    fill: "#4786d1"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M1075.82,1364.357l-44.776-44.776-14.7,14.7h0l-30.086,30.086,14.7,14.7,18.54-18.539v66.989h23.085v-67l18.54,18.539Z",
    transform: "translate(-874.277 -1169.753)",
    fill: "#f4b545"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M1084.535,59.052a1.234,1.234,0,0,1-1.23-1.158c-.089-1.446-.134-2.9-.134-4.325q0-1.2.041-2.371a1.234,1.234,0,0,1,2.466.085q-.039,1.133-.04,2.285c0,1.374.044,2.778.129,4.173a1.234,1.234,0,0,1-1.156,1.307l-.077,0m.48-13.13a1.289,1.289,0,0,1-.174-.012,1.234,1.234,0,0,1-1.05-1.394,57.086,57.086,0,0,1,1.322-6.591,1.234,1.234,0,1,1,2.385.631,54.569,54.569,0,0,0-1.264,6.305,1.234,1.234,0,0,1-1.22,1.062m34.458-4.7a14.944,14.944,0,0,1-3.941-.513,13.621,13.621,0,0,1-1.361-.45,1.234,1.234,0,0,1,.9-2.3,10.978,10.978,0,0,0,1.113.369,13.084,13.084,0,0,0,4.777.346,1.234,1.234,0,1,1,.259,2.454,16.711,16.711,0,0,1-1.747.093m70.576-1.043a1.234,1.234,0,0,1-1.123-.723c-.669-1.469-1.385-2.93-2.129-4.343a1.234,1.234,0,0,1,2.184-1.149c.765,1.455,1.5,2.958,2.191,4.47a1.235,1.235,0,0,1-1.122,1.746m-62.742-1.053a1.234,1.234,0,0,1-.623-2.3,10.558,10.558,0,0,0,4.1-4.122,1.234,1.234,0,1,1,2.184,1.148,13.014,13.014,0,0,1-5.039,5.106,1.228,1.228,0,0,1-.621.168m-18-2.556a1.232,1.232,0,0,1-.922-.413,18.6,18.6,0,0,1-3.573-6.033,1.234,1.234,0,0,1,2.322-.835,16.107,16.107,0,0,0,3.093,5.226,1.234,1.234,0,0,1-.92,2.055m-20.9-3.326a1.235,1.235,0,0,1-1.138-1.71,41.02,41.02,0,0,1,3.1-6.024,1.234,1.234,0,1,1,2.088,1.314,38.627,38.627,0,0,0-2.916,5.661,1.234,1.234,0,0,1-1.139.759m96.193-3.168a1.232,1.232,0,0,1-1.043-.574c-1.167-1.842-2.408-3.631-3.69-5.318a1.234,1.234,0,0,1,1.965-1.493c1.324,1.743,2.605,3.59,3.809,5.492a1.233,1.233,0,0,1-1.041,1.894m-51.767-1.953a1.234,1.234,0,0,1-1.215-1.027,14.153,14.153,0,0,0-2.363-5.516,1.234,1.234,0,0,1,2.034-1.4,16.618,16.618,0,0,1,2.761,6.5,1.235,1.235,0,0,1-1.218,1.441m-27.659-3.645a1.234,1.234,0,0,1-1.224-1.4,15.793,15.793,0,0,1,2.624-6.561,1.234,1.234,0,0,1,2.054,1.368,13.359,13.359,0,0,0-2.233,5.532,1.234,1.234,0,0,1-1.22,1.064m-9.726-2.262a1.234,1.234,0,0,1-.888-2.091,26.878,26.878,0,0,1,5.351-4.316,1.234,1.234,0,1,1,1.282,2.109,24.432,24.432,0,0,0-4.858,3.921,1.229,1.229,0,0,1-.887.377m81.188-2.6a1.23,1.23,0,0,1-.909-.4,63.679,63.679,0,0,0-4.593-4.531,1.234,1.234,0,1,1,1.64-1.844,66.026,66.026,0,0,1,4.772,4.707,1.234,1.234,0,0,1-.909,2.068m-50.981-2.139a1.229,1.229,0,0,1-.681-.206,16.536,16.536,0,0,0-5.627-2.323,1.234,1.234,0,0,1,.53-2.41,18.987,18.987,0,0,1,6.462,2.677,1.234,1.234,0,0,1-.683,2.262m-19.071-1.954a1.234,1.234,0,0,1-.327-2.424,31.837,31.837,0,0,1,4.494-.889,1.229,1.229,0,0,1,.417-.832,39.379,39.379,0,0,1,5.494-3.989,1.234,1.234,0,0,1,1.281,2.109,38.308,38.308,0,0,0-4.057,2.822,1.234,1.234,0,0,1-.755,2.156,29.334,29.334,0,0,0-6.218,1,1.236,1.236,0,0,1-.328.045m60.22-4.618a1.228,1.228,0,0,1-.71-.225,50.608,50.608,0,0,0-5.468-3.361,1.234,1.234,0,0,1,1.153-2.182,53.151,53.151,0,0,1,5.735,3.526,1.234,1.234,0,0,1-.711,2.243m-43.656-4.244a1.234,1.234,0,0,1-.494-2.365,54.24,54.24,0,0,1,6.33-2.3,1.234,1.234,0,0,1,.7,2.368,51.628,51.628,0,0,0-6.04,2.192,1.23,1.23,0,0,1-.492.1m32.042-1.853a1.232,1.232,0,0,1-.414-.072,39.885,39.885,0,0,0-6.154-1.66,1.234,1.234,0,1,1,.446-2.427,42.241,42.241,0,0,1,6.536,1.762,1.234,1.234,0,0,1-.414,2.4m-19.439-1.837a1.234,1.234,0,0,1-.188-2.453A42.843,42.843,0,0,1,1141.4.01c.2,0,.41-.005.614-.005h.3a1.234,1.234,0,0,1-.01,2.468h-.29c-.192,0-.382,0-.574,0a40.4,40.4,0,0,0-5.5.484,1.271,1.271,0,0,1-.191.015",
    transform: "translate(-960.184 -0.005)",
    fill: "#f4b545"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M334.2,1792.186q-.342,0-.682-.01a1.233,1.233,0,0,1-1.2-1.265,1.215,1.215,0,0,1,1.266-1.2,24.678,24.678,0,0,0,6.212-.656,1.234,1.234,0,1,1,.56,2.4,27.207,27.207,0,0,1-6.154.729m-7.114-1.127a1.242,1.242,0,0,1-.371-.057,31.915,31.915,0,0,1-4.262-1.7,1.232,1.232,0,0,1-.809.48,39.22,39.22,0,0,1-6.778.364,1.234,1.234,0,1,1,.072-2.466,38.756,38.756,0,0,0,4.945-.167,1.234,1.234,0,0,1,1.8-1.406,29.33,29.33,0,0,0,5.769,2.538,1.234,1.234,0,0,1-.37,2.41m-18.726-1.549a1.244,1.244,0,0,1-.2-.017,54.585,54.585,0,0,1-6.559-1.506,1.234,1.234,0,0,1,.7-2.366,52.241,52.241,0,0,0,6.261,1.438,1.234,1.234,0,0,1-.2,2.451m37.915-.188a1.234,1.234,0,0,1-.521-2.353,38.508,38.508,0,0,0,5.521-3.172,1.234,1.234,0,0,1,1.4,2.034,41,41,0,0,1-5.877,3.375,1.231,1.231,0,0,1-.519.115m-18.476-1.244a1.234,1.234,0,0,1-.491-2.366,13.37,13.37,0,0,0,4.888-3.434,1.234,1.234,0,0,1,1.867,1.614,15.817,15.817,0,0,1-5.774,4.085,1.224,1.224,0,0,1-.489.1m-32.024-2.314a1.238,1.238,0,0,1-.5-.107,42.607,42.607,0,0,1-5.177-2.739q-.389-.243-.773-.5a1.233,1.233,0,1,1,1.355-2.062c.24.157.481.313.725.464a40.208,40.208,0,0,0,4.877,2.579,1.234,1.234,0,0,1-.5,2.361m20.074-1.325a1.23,1.23,0,0,1-.877-.366,18.974,18.974,0,0,1-3.97-5.758,1.234,1.234,0,1,1,2.262-.984,16.554,16.554,0,0,0,3.462,5.007,1.234,1.234,0,0,1-.877,2.1m41.272-2.483a1.234,1.234,0,0,1-.831-2.146,54.714,54.714,0,0,0,4.484-4.608,1.234,1.234,0,1,1,1.865,1.615,57.24,57.24,0,0,1-4.688,4.818,1.23,1.23,0,0,1-.83.322m-72.271-3.408a1.227,1.227,0,0,1-.846-.336,42.4,42.4,0,0,1-4.532-5.029,1.234,1.234,0,0,1,1.958-1.5,39.815,39.815,0,0,0,4.266,4.736,1.234,1.234,0,0,1-.846,2.132m51.12-.094a1.251,1.251,0,0,1-.281-.032,1.234,1.234,0,0,1-.921-1.482,16.247,16.247,0,0,0,.423-3.689,15.6,15.6,0,0,0-.181-2.377,1.234,1.234,0,0,1,2.439-.379,18.129,18.129,0,0,1,.21,2.754,18.753,18.753,0,0,1-.488,4.251,1.234,1.234,0,0,1-1.2.954m-25.2-5.792a1.234,1.234,0,0,1-1.233-1.2c0-.181-.007-.363-.007-.545a16.155,16.155,0,0,1,1.22-6.41,1.234,1.234,0,0,1,2.267.975,13.906,13.906,0,0,0-1.019,5.436c0,.161,0,.321.007.48a1.233,1.233,0,0,1-1.2,1.265h-.033m54.968-.612a1.234,1.234,0,0,1-1.011-1.939c1.211-1.738,2.366-3.579,3.431-5.473a1.234,1.234,0,1,1,2.15,1.21c-1.1,1.962-2.3,3.871-3.557,5.674a1.234,1.234,0,0,1-1.014.528m-88.9-3.878a1.234,1.234,0,0,1-1.078-.631,53.079,53.079,0,0,1-2.9-6.074,1.234,1.234,0,0,1,2.289-.923,50.473,50.473,0,0,0,2.765,5.791,1.234,1.234,0,0,1-1.075,1.837m56.974-2.31a1.232,1.232,0,0,1-1-.513,11.271,11.271,0,0,0-.739-.92,13.1,13.1,0,0,0-3.818-2.882,1.233,1.233,0,1,1,1.115-2.2,15.582,15.582,0,0,1,4.542,3.437,13.749,13.749,0,0,1,.9,1.123,1.234,1.234,0,0,1-1,1.955m-17.656-4.478a1.234,1.234,0,0,1-.607-2.309,12.846,12.846,0,0,1,6.3-1.565h.006c.234,0,.47.006.705.017a1.234,1.234,0,0,1-.12,2.465,2.724,2.724,0,0,0-.59-.014,10.368,10.368,0,0,0-5.088,1.248,1.228,1.228,0,0,1-.6.158m-44.257-5.377a1.234,1.234,0,0,1-1.188-.905,66.191,66.191,0,0,1-1.451-6.544,1.234,1.234,0,0,1,2.433-.412,63.74,63.74,0,0,0,1.4,6.3,1.235,1.235,0,0,1-1.19,1.562m-2.22-12.95a1.234,1.234,0,0,1-1.229-1.14c-.147-1.935-.221-3.92-.221-5.9l0-.778a1.234,1.234,0,0,1,1.233-1.222h.012a1.233,1.233,0,0,1,1.222,1.245l0,.755c0,1.92.072,3.843.214,5.715a1.234,1.234,0,0,1-1.137,1.324c-.032,0-.064,0-.095,0m.118-13.145c-.037,0-.074,0-.112,0a1.234,1.234,0,0,1-1.119-1.339c.147-1.63.343-3.29.585-4.934a1.234,1.234,0,1,1,2.441.359c-.235,1.6-.426,3.211-.568,4.8a1.234,1.234,0,0,1-1.227,1.124",
    transform: "translate(-237.78 -1526.992)",
    fill: "#3b82f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1027",
    "data-name": "Group 1027",
    transform: "translate(13.112 159.342)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1026",
    "data-name": "Group 1026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M158.978,1414.373a23.561,23.561,0,1,0-7.381,32.493,23.562,23.562,0,0,0,7.381-32.493",
    transform: "translate(-115.476 -1403.364)",
    fill: "#4786d1"
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M139.727,1375.057a23.562,23.562,0,1,0-7.381,32.493,23.562,23.562,0,0,0,7.381-32.493",
    transform: "translate(-85.299 -1209.17)",
    fill: "#3b82f4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M227.825,1478.785l-17.314.257.084,5.683h0l.173,11.634,5.683-.084-.106-7.169,13.144,12.76,4.4-4.53-13.146-12.761,7.169-.106Z",
    transform: "translate(-186.609 -1310.88)",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M2375.325,558.863l3.771-1.982a1.164,1.164,0,0,1,1.69,1.228l-.72,4.2a1.164,1.164,0,0,0,.335,1.031l3.051,2.974a1.164,1.164,0,0,1-.645,1.986l-4.216.613a1.165,1.165,0,0,0-.877.637l-1.885,3.82a1.164,1.164,0,0,1-2.088,0l-1.885-3.82a1.165,1.165,0,0,0-.877-.637l-4.216-.613a1.164,1.164,0,0,1-.645-1.986l3.05-2.974a1.164,1.164,0,0,0,.335-1.031l-.72-4.2a1.164,1.164,0,0,1,1.689-1.228l3.771,1.982a1.164,1.164,0,0,0,1.084,0",
    transform: "translate(-2097.146 -493.53)",
    fill: "#4786d1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M1764.128,2112.33a9.211,9.211,0,1,1,9.212-9.211,9.22,9.22,0,0,1-9.212,9.211m0-15.888a6.677,6.677,0,1,0,6.677,6.677,6.685,6.685,0,0,0-6.677-6.677",
    transform: "translate(-1555.658 -1856.158)",
    fill: "#4786d1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M1804.107,2138.41a4.691,4.691,0,1,1-4.691-4.691,4.691,4.691,0,0,1,4.691,4.691",
    transform: "translate(-1590.946 -1891.45)",
    fill: "#4786d1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M544.576,29.647a7.8,7.8,0,1,1-7.8-7.8,7.8,7.8,0,0,1,7.8,7.8",
    transform: "translate(-468.911 -19.365)",
    fill: "#4786d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1030",
    "data-name": "Group 1030",
    transform: "translate(212.704 29.052)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1029",
    "data-name": "Group 1029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1028",
    "data-name": "Group 1028",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M1900.39,256.492a21.887,21.887,0,1,0,16.1,26.433,21.887,21.887,0,0,0-16.1-26.433",
    transform: "translate(-1873.333 -255.869)",
    fill: "#4786d1"
  }))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M1897.7,254.4a21.887,21.887,0,1,0-26.433,16.1,21.887,21.887,0,0,0,26.433-16.1",
    transform: "translate(-1643.971 -201.533)",
    fill: "#f4b545"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M1950.058,330.389l4.389,3.867a1.6,1.6,0,0,0,2.652-1.09l.4-5.835a1.6,1.6,0,0,1,.781-1.267l5.033-2.979a1.6,1.6,0,0,0-.218-2.859l-5.426-2.183a1.6,1.6,0,0,1-.963-1.134l-1.278-5.708a1.6,1.6,0,0,0-2.787-.677l-3.753,4.486a1.6,1.6,0,0,1-1.376.566l-5.823-.549a1.6,1.6,0,0,0-1.5,2.441l3.107,4.956a1.6,1.6,0,0,1,.113,1.484l-2.321,5.369a1.6,1.6,0,0,0,1.857,2.185l5.673-1.423a1.6,1.6,0,0,1,1.446.351",
    transform: "translate(-1719.669 -274.757)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.4ec8219278ae5c7f13e3f75b7a3cbc95.svg";
export { ForwardRef as ReactComponent };